<!-- 
<div>
	{{app.data().asOfUtc}}
</div>
<common-button-row>
	<button (click)="getAppData()" class="btn btn-secondary">Get app data</button>
</common-button-row> -->

<div
	style="background-color: antiquewhite;border:solid 1px orange; display: inline-block; max-width: 500px; padding:1em; margin:2em;">

	This is the overall app homepage. We plan to add high level reporting here, so anyone can get a sense of what is
	going on, across all the teams.
	<br><br>
	Share your ideas on what you would like to see here. See the Ideas and Bugs menu.
	<br><br>
	Each team area will have a similar "Overview" page, with details specific to that area.
	<br><br>
	We expect to start implementing features into the Home page and the team Overview pages later this year.

</div>